import './nav-menu.css';
import { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { userLoaded, tourStarted } from '../../redux/actions';
import { useNavigate } from 'react-router-dom';
import { serverFetch } from '../../server';
import NavMenuItem from './nav-menu-item';
import { Image, message } from 'antd';
import { isMobile } from '../../extensions/design';
import { licenseModuleBase, licenseModuleMessages } from '@/extensions';
import { subscribeCompanyRefresh } from '@/services/companyRefreshService';

const NavMenu = () => {
    const d = useDispatch();
    const navigate = useNavigate();
    const [items, setItems] = useState([]);
    const [company, setCompany] = useState();
    const user = useSelector((s) => s.user);

    const activeLicenseModules = company?.activeLicense?.activeModules;

    const loadCompany = useCallback(() => {
        serverFetch(`company/current`)
            .then(data => setCompany(data))
            .catch(e => message.error(e.userMessage));
    }, []);

    const logout = () => {
        serverFetch(`auth/logout`, { method: 'POST' })
            .then(() => {
                d(userLoaded());
            })
            .catch(() => {
                message.error('Ошибка выхода из системы');
            });
    };

    const startTour = useCallback(() => {
        d(tourStarted());
        navigate('/');
    }, [d, navigate]);    

    const logoutTooltip = user ? <div>
        <div>Выход из системы</div>
        <div>{user.userName}</div>
        <div>{user.email}</div>
    </div> : null;

    useEffect(() => {
      const newItems = [];
      if (isMobile) {
        licenseModuleBase(activeLicenseModules) && user.companyId && newItems.push(
            getItem('Визиты', 'visits', '/visits', 'sale.svg', null, false, null, 'visits'),
            getItem('Запись', 'records', '/records', 'calendar.svg', null, false, null, 'records'),
            getItem('Клиенты', 'clients', '/clients', 'person.svg', null, false, null, 'clients'),
            
        );
        newItems.push(getItem('Помощь', 'help', 'https://kb.sport24.cloud/', 'help.svg', null, false, 'База знаний', 'help', true));
        newItems.push(getItem('Выход', 'logout', '', 'exit.svg', logout),);
      }
      else 
      {
        licenseModuleBase(activeLicenseModules) && user.companyId && newItems.push(
            getItem('Визиты', 'visits', '/visits', 'sale.svg', null, false, null, 'visits'),
            getItem('Запись', 'records', '/records', 'calendar.svg', null, false, null, 'records'),
            getItem('Клиенты', 'clients', '/clients', 'person.svg', null, false, null, 'clients'),
            getItem('Оплаты', 'payments', '/payments', 'card.svg', null, false, null, 'payments'),
            getItem('Продажи', 'sales', '/sales', 'sale2.svg', null, false, null, 'sales'),
        );
        licenseModuleBase(activeLicenseModules) && user.companyId && newItems.push && company.userRoles !== 20 && newItems.push (
            getItem('Склад', 'stock', '/stock', 'stock.svg', null, false, null, 'stock'),
        );
        licenseModuleBase(activeLicenseModules) && user.companyId && newItems.push(
            getItem('Отчеты', 'reports', '/reports', 'print.svg', null, false, null, 'reports'),
        );
        user.isAdmin && newItems.push(getItem('Реестры', 'reestrs', '/reestrs', 'card.svg', null, false, null, 'reestrs'));
        licenseModuleMessages(activeLicenseModules) && user.companyId && newItems.push(
            getItem('Диалоги', 'messages', '/dialogs', 'mail.svg', null, false, null, 'messages', false, company?.dialogUnreadQty ?? 0),
        );
        user.isSuperadmin && newItems.push(getItem('Компании', 'companies', '/companies', 'monitor.svg', null, false, null, 'companies'));
        licenseModuleBase(activeLicenseModules) && user.isAdmin && newItems.push(getItem('Монитор', 'logs', '/logs', user.isAdmin ? 'monitor.svg' : 'monitor-disabled.svg', null, false, null, 'monitor'));
        user.isAdmin && newItems.push(getItem('Лицензии', 'license', '/license', 'key.svg', null, false, null, 'licenses'));
        user.companyId && newItems.push(getItem('Настройки', 'settings', '/settings', user.isAdmin ? 'settings.svg' : 'settings-disabled.svg', null, false, null, 'settings'));
        licenseModuleBase(activeLicenseModules) && user.isAdmin && user.companyId && newItems.push(getItem('Сервис', 'service', '/service', user.isAdmin ? 'service.svg' : 'service-disabled.svg', null, !user.isAdmin, null, 'service'));
        licenseModuleBase(activeLicenseModules) && newItems.push(getItem('Тур', 'tour', '', 'video-camera-outlined.svg', startTour, false, 'Запустить экскурсию по всем страницам', 'tour'));
        newItems.push(getItem('Помощь', 'help', 'https://kb.sport24.cloud/', 'help.svg', null, false, 'База знаний', 'help', true));
        newItems.push(getItem('Выход', 'logout', '', 'exit.svg', logout, false, logoutTooltip, 'exit'));
      }
      setItems(newItems)
      // eslint-disable-next-line
    }, [user, startTour, company]);

    useEffect(() => {
        loadCompany();
    }, [loadCompany])

    useEffect(() => subscribeCompanyRefresh(loadCompany), [loadCompany])

    function getItem(label, key, urlTo, img, onClick, disabled = false, tooltip = null, id = '', external = false, badgeCount = 0) {
        return { key, label, url: urlTo, img, onClick, disabled, tooltip, id, external, badgeCount };
    }

    const logoUrl = company?.pictureFileName ? `${process.env.REACT_APP_API_BASE_URL}/api/image/${company?.pictureFileName}` : "/images/logo.svg";
    return (
        <>
            <div className='nav-menu-container' data-tour-target="nav-menu">
                <div className='sider-logo-new' id={`tour-item-nav-menu-dashboard`}><a href='/' ><Image src={logoUrl} preview={false} width={32} /></a></div>
                {items.map(i => <NavMenuItem {...i} key={i.key} itemId={`tour-item-nav-menu-${i.id}`} />)}
                {/* <div className='nav-menu-footer'>(с) Компания Проффит 2010 - 2025</div> */}
                <div className='nav-menu-footer'>{process.env.REACT_APP_VERSION}</div>
            </div>
        </>
    );
};

export default NavMenu;